import script from "./MyTicketAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./MyTicketAddress.vue?vue&type=script&setup=true&lang=js"

import "./MyTicketAddress.vue?vue&type=style&index=0&id=d3387c22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3387c22"]])

export default __exports__